import React from 'react';

import Layout from '../Layout/Layout';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

import s from './Unauthorized.css';


const Unauthorized = () =>
    <Layout column fullscreen className={s.component}>
        <ErrorMessage
            title="You are not authorized to view the conversation."
            message="If you feel you have reached this page in error, please contact the Practice."
        />
    </Layout>;

export default Unauthorized;
